import type { Dispatch, RootState, Store } from '@swf/core/store';
import rootStore, { select } from '@swf/core/store';
import type { WidgetContainer, WidgetStaticProps } from '@swf/core/types/Widget';
import { flattenWidgets } from '@swf/core/utils/flattenWidgets';
import widgets from '@swf/widgets/index';

interface Meta {
  isAuthenticated?: boolean;
  dispatch: Dispatch;
}

export const fetchProperties = async (type: string): Promise<WidgetStaticProps> =>
  widgets[type] ? (await widgets[type].preload()).default : {};

export const loadWidget = async (
  widgetConfig: WidgetContainer,
  { isAuthenticated, dispatch }: Meta
) => {
  const { services } = widgetConfig;
  if (services) {
    await Promise.all(
      Object.keys(services)
        .filter((key) => {
          const { onLoad, onAuth, subscribe } = services[key].config;
          return !subscribe && (onLoad || (onAuth && isAuthenticated));
        })
        .map((key) => dispatch.widgets.fetchData({ key, widgetConfig }))
    );
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadModel = async (promise: Promise<any>) => {
  const { default: model } = await promise;
  // eslint-disable-next-line import/no-named-as-default-member
  if (!rootStore.dispatch[model.name]) {
    rootStore.addModel(model);
  }
};

export const preload = async (store: Store) => {
  const { layout } = select.page.get(store.getState());
  if (layout) {
    const list = flattenWidgets(layout);
    await Promise.all(list.map((widget) => loadWidget(widget, { dispatch: store.dispatch })));
  }
};

export const widgetLoading = (rootState: RootState) =>
  rootState.loading.effects.widgets.fetchData || rootState.loading.effects.page.fetchPage;
